export const PAYMENT_METHOD = {
  STRIPE: "STRIPE",
  PAYPAL: "PAYPAL",
  STRIPE_SAVED_CARD: "STRIPE SAVED CARD",
}

export const PROMO_CODE_TYPES = {
  PRODUCT_OFFER: "product-offer",
  PRODUCT_DISCOUNT: "product-discount",
}

export const BILLING_INTERVAL_TYPES = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
}

export const INTERVAL_DAYS = {
  [BILLING_INTERVAL_TYPES.DAY]: 1,
  [BILLING_INTERVAL_TYPES.WEEK]: 7,
  [BILLING_INTERVAL_TYPES.MONTH]: 30,
  [BILLING_INTERVAL_TYPES.YEAR]: 365,
}

export const INTERVAL_TYPE_ADVERBS = {
  [BILLING_INTERVAL_TYPES.DAY]: "daily",
  [BILLING_INTERVAL_TYPES.WEEK]: "weekly",
  [BILLING_INTERVAL_TYPES.MONTH]: "monthly",
  [BILLING_INTERVAL_TYPES.YEAR]: "annually",
}

export const INTERVAL_TYPE_ADJECTIVES = {
  [BILLING_INTERVAL_TYPES.DAY]: "daily",
  [BILLING_INTERVAL_TYPES.WEEK]: "weekly",
  [BILLING_INTERVAL_TYPES.MONTH]: "monthly",
  [BILLING_INTERVAL_TYPES.YEAR]: "annual",
}



// WEBPACK FOOTER //
// ./src/store/payment/payment.constants.js